import { ListItem, ListItemText } from '@material-ui/core';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import * as React from 'react';

import { logger } from '../../common/logger';

interface AgentFeedItemErrorBoundaryProps {
    children: React.ReactNode;
    itemKey: string;
}

interface AgentFeedItemErrorBoundaryState {
    hasError: boolean;
}

export class AgentFeedItemErrorBoundary extends React.Component<
    AgentFeedItemErrorBoundaryProps,
    AgentFeedItemErrorBoundaryState
> {
    static getDerivedStateFromError(): AgentFeedItemErrorBoundaryState {
        return { hasError: true };
    }

    constructor(props: AgentFeedItemErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        logger.error(error, {
            componentStack: errorInfo.componentStack,
            itemKey: this.props.itemKey,
            message: 'Error rendering Orbit feed item'
        });
    }

    render() {
        if (this.state.hasError) {
            const errorMessage = (
                <div className="agent__feedItemError" role="alert">
                    <ErrorOutlineIcon className="agent__feedItemErrorIcon" />
                    <div>
                        <div className="agent__feedItemErrorTitle">Unable to display response</div>
                        <div className="agent__feedItemErrorMessage">
                            Orbit could not display this response. You can continue the conversation.
                        </div>
                    </div>
                </div>
            );
            return (
                <ListItem alignItems="flex-start" className="agent__row agent__row--assistant">
                    <ListItemText
                        secondary={errorMessage}
                        secondaryTypographyProps={{ color: 'initial', component: 'div' as 'div' }}
                    />
                </ListItem>
            );
        }

        return this.props.children;
    }
}
